module.exports = __webpack_public_path__ + "prod/1.42.2/img/bankeysPC-downloadBg.071fc293.png";